import CCS from '../../assets/job-boards_images/ccs.png'
import IBM from '../../assets/job-boards_images/IBM.svg'
import Google from '../../assets/job-boards_images/Google.webp'
import GrandCircus from '../../assets/job-boards_images/gc.png'
import DTE from '../../assets/job-boards_images/DTE.png'
import COMPASSDetroit from '../../assets/job-boards_images/compass.png'

const JobBoardData = [
  {
    id: 1,
    name: 'CCS',
    avatar: CCS,
    url: 'https://bit.ly/ccs-jobs-25',
  },
  {
    id: 2,
    name: 'DTE',
    avatar: DTE,
    url: 'https://bit.ly/dte-jobs-25',
  },
  {
    id: 3,
    name: 'Google',
    avatar: Google,
    url: 'https://bit.ly/google-jobs-25',
  },
  {
    id: 4,
    name: 'Grand Circus',
    avatar: GrandCircus,
    url: 'https://bit.ly/grandcircus-jobs-25',
  },
  {
    id: 5,
    name: 'IBM',
    avatar: IBM,
    url: 'https://bit.ly/ibm-jobs-25',
  },
  {
    id: 6,
    name: 'Resume Drop',
    avatar: COMPASSDetroit,
    url: 'https://bit.ly/iwd-resume-drop',
  },


];
export default  JobBoardData;

